import { Stack, Button, Typography, Box, Avatar } from "@mui/material";
import { green } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";



const Successful = () => {

  const [ returnURL, setReturnURL ] = useState("");
  const navigate = useNavigate();
  useEffect(()=>{
    let returnURL = localStorage.getItem("returnURL")+"/?payRef="+localStorage.getItem("payRef");
    if (returnURL) {
      setReturnURL(returnURL) 
      localStorage.clear()
    }
  }, [])
  return (
    <Stack>
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ bgcolor: green[500], width: "150px", height: "150px" }}>
          <CheckIcon sx={{ width: "150px", height: "150px" }} />
        </Avatar>
        <Typography
          variant="h4"
          component="h2"
          sx={{ mt: 3 }}
          fontWeight="bold"
        >
          Payment Successful !
        </Typography>
        <Button
          sx={{ mt: 10, width: "150px" }}
          variant="contained"
          size="small"
          onClick={()=>{ 
            window.location=returnURL+"";
          }}
        >
          Back to PSU Internal System
        </Button>
      </Box>
    </Stack>
  );
};

export default Successful;
